<template>
  <div class="blockquote container">
    <Headline :size="3">
      <span
        v-editable.text.oneLine="resource.columns.quote"
        :class="[`blockquote__quote--${focusClass}`]"
        class="blockquote__quote"
      />
      <span
        v-if="resource.columns.byline"
        v-editable.text.oneLine="resource.columns.byline"
        :class="[`blockquote__byline--${focusClass}`]"
        class="blockquote__byline"
      />
    </Headline>
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Headline from 'beisheim/components/elements/headline'
import { Resource } from 'beisheim/models'

export default {
  components: {
    Headline
  },
  mixins: [ editable ],
  computed: {
    parent () {
      return Resource.find(this.resource.parent_id)
    },
    focusClass () {
      if (!this.parent) {
        return ''
      }

      return this.parent.resource_class_name === 'Project' && this.parent.columns.focus && this.parent.columns.focus.toLowerCase()
    }
  }
}
</script>

<style scoped lang="scss">
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/zindex';
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/breakpoints';
  @import 'beisheim/scss/grid';

  .blockquote {
    padding: 0;
    margin: scale(14) auto;
    @include grid-spacing(padding-left, 4);
    @include grid-spacing(padding-right, 4);
    &__quote {

      display: block;

      &:before {
        content: '“';
        position: absolute;
        transform: translateX(-125%);
      }
      &:after {
        content: '”';
        position: absolute;
        transform: translateX(25%);
      }

      color: gray(2);

      .headline__text {
        color: gray(2);
      }

      &--kultur, &--kultur .headline__text { color: brand(1); }
      &--sport, &--sport .headline__text { color: brand(2); }
      &--bildung, &--bildung .headline__text { color: brand(3); }
      &--gesundheit, &--gesundheit .headline__text { color: brand(4); }
    }

    &__byline {
      display: inline-block;
      font-size: font-size(0);

      &:before {
        content: '— ';
      }

      &--kultur { color: brand(1); }
      &--sport { color: brand(2); }
      &--bildung { color: brand(3); }
      &--gesundheit { color: brand(4); }
    }
  }

</style>
